// extracted by mini-css-extract-plugin
export default {"cellCheckbox":"Row_cellCheckbox__30ZRv","photo":"Row_photo__XzpI6","currentlySelected":"Row_currentlySelected__GV4YJ","placeHolderShimmer":"Row_placeHolderShimmer__I3DFy"};